import emailjs from "@emailjs/browser";

const PUBLIC_KEY =
  process.env.REACT_APP_EMAILJS_ENQUIRY_PUBLIC_KEY;

const ENQUIRY_SERVICE_ID =
  process.env.REACT_APP_EMAILJS_ENQUIRY_SERVICE_ID;

const TEMPLATE_ID =
  process.env.REACT_APP_EMAILJS_ENQUIRY_TEMPLATE_ID;

const ENQUIRY_EMAIL =
  process.env.REACT_APP_ENQUIRY_EMAIL;


export const sendEnquiry = async (formData) => {
  try {
 

    if (!PUBLIC_KEY) {
      throw new Error(
        "EmailJS enquiry public key is missing."
      );
    }

    if (!ENQUIRY_SERVICE_ID) {
      throw new Error(
        "EmailJS enquiry service ID is missing."
      );
    }

    if (!TEMPLATE_ID) {
      throw new Error(
        "EmailJS enquiry template ID is missing."
      );
    }

    if (!ENQUIRY_EMAIL) {
      throw new Error(
        "REACT_APP_ENQUIRY_EMAIL is missing from .env"
      );
    }

    

    const name =
      formData?.name?.trim() || "";

    const email =
      formData?.email?.trim() || "";

    const phone =
      formData?.phone?.trim() || "";

    const serviceTitle =
      formData?.serviceTitle?.trim() || "";

    const subService =
      formData?.subService?.trim() || "";

   
    const message =
      formData?.message?.trim() || "";

    

    const templateParams = {
     
      to_email: ENQUIRY_EMAIL,
      from_name: name,
      from_email: email,
      phone: phone,
      service_title: serviceTitle,
      sub_service: subService,
      message: message,
      experience:
        formData?.experience || "",
      skills:
        formData?.skills || "",
      resume:
        formData?.resume || "",
    };

    console.log(
      "EmailJS Enquiry Template Params:",
      templateParams
    );


    const response = await emailjs.send(
      ENQUIRY_SERVICE_ID,
      TEMPLATE_ID,
      templateParams,
      PUBLIC_KEY
    );


    console.log(
      "Enquiry email sent successfully:",
      response
    );

    return {
      success: true,
      response,
    };

  } catch (error) {
  

    console.error(
      "EmailJS Enquiry Error:",
      error
    );

    return {
      success: false,
      error,
    };
  }
};